import { Memo } from '@contact/upgrade';

export interface IContactEntry {
  id: string;
  entryDate: Date;
  beginDate: Date;
  endDate: Date;
  canalName: string;
  canalDirection: string;
  campaignType: string;
  contactUri: string;
  contactFirstName: string;
  contactCompanyName: string;
  contactLastName: string;
  contactUuid: string;
  csrUuid: string;
  csrLogin: string;
  csrFirstname: string;
  csrLastname: string;
  description: string;
  technicalId: string;
  connectionId: string;
  epticaRequestId?: string;
  dimeloRequestId?: string;
  interactionType?: string;
  interactionStatus?: string;
  parentInteractionUuid?: string;
  skills: {}[];
  contents: IContactEntryContent[];
  data?: any;
  memo?: Memo;
  extraData: any;
  redirected: boolean;
  visibilityType: ContactEntryVisibilityType | string;
  isEpticaSynchronized: boolean;
  chatConversationUuid: string;
  notHandledReason: ContactEntryNotHandledReason | string;
  delayBeforeNotHandledReason: number;
}

export interface IContactEntryContent {
  entryDate: string;
  contactEntryUuid: string;
  contentType: string;
  content: string;
}

export enum ContactEntryVisibilityType {
  AUTHORIZED,
  RESTRICTED,
  PRIVATE,
}

export enum ContactEntryNotHandledReason {
  NONE,
  DISSUADED,
  ABANDONED,
}
